import { render, staticRenderFns } from "./McRadarChart.vue?vue&type=template&id=55bddf88&"
import script from "./McRadarChart.vue?vue&type=script&lang=js&"
export * from "./McRadarChart.vue?vue&type=script&lang=js&"
import style0 from "./McRadarChart.vue?vue&type=style&index=0&id=55bddf88&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports